/**
 * 공통 코드 타입 정의
 */

/** 공통코드 DTO */
export type CommonCodeDto = {
    seqNo: number;
    grpCode: string;
    comCode: string;
    comCdName: string;
    comSeqno: number;
    val1: string | null;
    val2: string | null;
    val3: string | null;
    val4: string | null;
    val5: string | null;
    val6: string | null;
    val7: string | null;
    val8: string | null;
    val9: string | null;
    val10: string | null;
    useYn: string;
    insDate: string;
    insUser: string;
    updDate: string | null;
    updUser: string | null;
};

/** 공통코드 목록 조회 응답 DTO */
export type GetCommonCodeListResponseDto = {
    totalCount: number;
    codes: CommonCodeDto[];
};

/** 공통코드 Domain Model */
export type CommonCode = {
    code: string;
    name: string;
    value: string;
};

/** DTO -> Domain 변환 */
export const commonCodeFromDto = (dto: CommonCodeDto): CommonCode => ({
    code: dto.comCode,
    name: dto.comCdName,
    value: dto.val1 || dto.comCode
});

/**
 * 슬롯 정보 타입 (SLOTINFO)
 * VAL1=월, VAL2=화, VAL3=수, VAL4=목, VAL5=금, VAL6=토, VAL7=일
 */
export interface SlotInfo {
    slotCode: string;       // SLOT1, SLOT2, SLOT3, SLOT4
    slotName: string;       // 아침점심피크, 오후논피크, 저녁피크, 심야논피크
    order: number;          // 순서
    monday: number;         // VAL1 - 월요일 기준 건수
    tuesday: number;        // VAL2 - 화요일 기준 건수
    wednesday: number;      // VAL3 - 수요일 기준 건수
    thursday: number;       // VAL4 - 목요일 기준 건수
    friday: number;         // VAL5 - 금요일 기준 건수
    saturday: number;       // VAL6 - 토요일 기준 건수
    sunday: number;         // VAL7 - 일요일 기준 건수
}

/** CommonCodeDto -> SlotInfo 변환 */
export const slotInfoFromDto = (dto: CommonCodeDto): SlotInfo => ({
    slotCode: dto.comCode,
    slotName: dto.comCdName,
    order: dto.comSeqno || 0,
    monday: parseInt(dto.val1 || '0', 10),
    tuesday: parseInt(dto.val2 || '0', 10),
    wednesday: parseInt(dto.val3 || '0', 10),
    thursday: parseInt(dto.val4 || '0', 10),
    friday: parseInt(dto.val5 || '0', 10),
    saturday: parseInt(dto.val6 || '0', 10),
    sunday: parseInt(dto.val7 || '0', 10),
});

/**
 * 요일에 해당하는 슬롯 건수 반환
 * @param slotInfo 슬롯 정보
 * @param dayOfWeek 요일 (0=일, 1=월, 2=화, 3=수, 4=목, 5=금, 6=토)
 */
export const getSlotCountByDay = (slotInfo: SlotInfo, dayOfWeek: number): number => {
    switch (dayOfWeek) {
        case 0: return slotInfo.sunday;
        case 1: return slotInfo.monday;
        case 2: return slotInfo.tuesday;
        case 3: return slotInfo.wednesday;
        case 4: return slotInfo.thursday;
        case 5: return slotInfo.friday;
        case 6: return slotInfo.saturday;
        default: return 0;
    }
};
